import { endDateFilter, startDateFilter } from 'modules/cms/banners/constants';
import { createdATFilter } from 'modules/common/constants';
import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { EmptyFilter, OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';

export const specialOfferStatusFilter: Filter = {
  filter: 'offerOrder:status.title',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'status',
  field: 'status',
  transform: (value) => {
    const now = new Date();

    if (Array.isArray(value)) {
      if (value.length === 0) return new EmptyFilter();

      const filters = value.map((status) => {
        switch (status) {
          case OFFER_STATUS.ACTIVE:
            return new OperatorFilter({
              type: 'AND',
              filters: [
                new TermFilter({ field: 'startDate', value: { $lte: now } }),
                new TermFilter({ field: 'endDate', value: { $gte: now } }),
              ],
            });
          case OFFER_STATUS.SCHEDULED:
            return new TermFilter({ field: 'startDate', value: { $gt: now } });
          case OFFER_STATUS.FINISHED:
            return new TermFilter({ field: 'endDate', value: { $lt: now } });
          default:
            return new EmptyFilter();
        }
      });

      return new OperatorFilter({
        type: 'OR',
        filters,
      }).toQuery();
    }

    switch (value) {
      case OFFER_STATUS.ACTIVE:
        return new OperatorFilter({
          type: 'AND',
          filters: [
            new TermFilter({ field: 'startDate', value: { $lte: now } }),
            new TermFilter({ field: 'endDate', value: { $gte: now } }),
          ],
        }).toQuery();
      case OFFER_STATUS.SCHEDULED:
        return new TermFilter({ field: 'startDate', value: { $gt: now } }).toQuery();
      case OFFER_STATUS.FINISHED:
        return new TermFilter({ field: 'endDate', value: { $lt: now } }).toQuery();
      default:
        return new EmptyFilter();
    }
  },
  options: [
    {
      value: OFFER_STATUS.ACTIVE,
      translate: true,
      label: 'offerOrder:status.ACTIVE',
    },
    {
      value: OFFER_STATUS.SCHEDULED,
      translate: true,
      label: 'offerOrder:status.SCHEDULED',
    },
    {
      value: OFFER_STATUS.FINISHED,
      translate: true,
      label: 'productDiscount:status.FINISHED',
    },
  ],
};

export const specialOfferFilters = [specialOfferStatusFilter, startDateFilter, endDateFilter, createdATFilter];

export const defaultSpecialOfferFilters = [specialOfferStatusFilter, startDateFilter, endDateFilter];
